import { axios, baseURL } from '@/plugins/axios.js'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchStockAdjustments(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/stock_adjustments', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    fetchStockAdjustment(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/api/v1/stock_adjustments/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    createStockAdjustment(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .post('api/v1/stock_adjustments', params)
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    voidStockAdjustment(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/api/v1/stock_adjustments/${params.id}`, { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    advancedSearch(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/stock_adjustments/advanced', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    lastStockAdjustments(ctx, params) {
      return new Promise((resolve, reject) => {
        axios
          .get('/api/v1/stock_adjustments/last', { params })
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    exportStockAdjustment(ctx, params) {
      return new Promise((resolve, reject) => {
        const urlParams = new URLSearchParams();
        urlParams.append("search_text", params.search_text || "")
        urlParams.append("start_date", params.start_date || "")
        urlParams.append("end_date", params.end_date || "")
        urlParams.append("location", params.location || "")
        fetch(`${baseURL}/api/v1/stock_adjustments/export?${urlParams}`, {
          method: "GET",
          headers: Object.assign($cookies.get("userAuth"), { "Access-Control-Allow-Origin": "*" })
        })
          .then((response) => {
            resolve(response.blob());
          })
          .catch((error) => reject(error));
      });
    },
  }
}